import React from 'react';
import LeftSection from './left-section';
import RightSection from './right-section';
import CreatOrderContextProvider from './contexts/create-order-context';

const CreateOrder = () => {
  return (
    <CreatOrderContextProvider>
      <div className='grid md:grid-cols-3 gap-4 items-start'>
        <LeftSection />
        <RightSection />
      </div>
    </CreatOrderContextProvider>
  );
};

export default CreateOrder;
